import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 m-3"
}
const _hoisted_2 = {
  key: 1,
  class: "wl-kpis"
}
const _hoisted_3 = { class: "wl-stat wl-stat--dark" }
const _hoisted_4 = { class: "wl-stat__head" }
const _hoisted_5 = { class: "wl-stat__title" }
const _hoisted_6 = { class: "wl-stat__value" }
const _hoisted_7 = { class: "wl-stat__meta" }
const _hoisted_8 = { class: "wl-stat" }
const _hoisted_9 = { class: "wl-stat__head" }
const _hoisted_10 = { class: "wl-stat__title" }
const _hoisted_11 = { class: "wl-stat__value" }
const _hoisted_12 = { class: "wl-stat__meta" }
const _hoisted_13 = { class: "wl-stat" }
const _hoisted_14 = { class: "wl-stat__head" }
const _hoisted_15 = { class: "wl-stat__title" }
const _hoisted_16 = { class: "wl-stat__value" }
const _hoisted_17 = { class: "wl-stat__meta" }
const _hoisted_18 = { class: "assets-grid-card" }
const _hoisted_19 = { class: "assets-grid-card__header" }
const _hoisted_20 = { class: "assets-grid-title" }
const _hoisted_21 = { class: "assets-grid-title__text" }
const _hoisted_22 = { class: "text-muted small" }
const _hoisted_23 = { class: "assets-grid-card__body" }
const _hoisted_24 = { class: "wl-assets-search-wrap" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = {
  key: 0,
  class: "wp-grid-wrap"
}
const _hoisted_27 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_28 = { class: "wp-loading__text" }
const _hoisted_29 = { class: "text-muted small font-monospace" }
const _hoisted_30 = { class: "text-muted small font-monospace" }
const _hoisted_31 = { class: "text-muted small font-monospace" }
const _hoisted_32 = { class: "text-muted small font-monospace" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.statsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.kpis.total')), 1),
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-broadcast wl-stat__icon" }, null, -1))
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.stats.total), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.kpis.totalMeta')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.kpis.forecastable')), 1),
              _cache[4] || (_cache[4] = _createElementVNode("i", {
                class: "bi bi-graph-down-arrow wl-stat__icon",
                style: {"color":"#4870b8"}
              }, null, -1))
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.stats.forecastable), 1),
            _createElementVNode("div", {
              class: "wl-stat__accent",
              style: _normalizeStyle({ width: _ctx.stats.total ? `${(_ctx.stats.forecastable / _ctx.stats.total) * 100}%` : '0%', background: '#4870b8' })
            }, null, 4),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.kpis.forecastableMeta')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.kpis.urgent')), 1),
              _cache[5] || (_cache[5] = _createElementVNode("i", {
                class: "bi bi-exclamation-circle-fill wl-stat__icon",
                style: {"color":"#ac4c3a"}
              }, null, -1))
            ]),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.stats.urgent), 1),
            _createElementVNode("div", {
              class: "wl-stat__accent",
              style: _normalizeStyle({ width: _ctx.stats.total ? `${(_ctx.stats.urgent / _ctx.stats.total) * 100}%` : '0%', background: '#ac4c3a' })
            }, null, 4),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.kpis.urgentMeta')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-battery-half" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.title')), 1),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('components.infrastructure.fleetHealth.subtitle')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            type: "text",
            class: "form-control wl-assets-search",
            placeholder: _ctx.$t('components.infrastructure.fleetHealth.searchPlaceholder'),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
          }, null, 40, _hoisted_25), [
            [_vModelText, _ctx.search]
          ])
        ]),
        (_ctx.hasActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_ctx.gridLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", {
                      class: "spinner-border wp-loading__spinner",
                      role: "status"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('components.infrastructure.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxDataGrid, {
                ref: "gridRef",
                class: "ni-grid",
                "data-source": _ctx.dataSource,
                "remote-operations": true,
                "key-expr": "assetId",
                "hover-state-enabled": true,
                "column-auto-width": true,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": false,
                "row-alternation-enabled": true,
                "column-hiding-enabled": _ctx.isNarrowViewport,
                "word-wrap-enabled": false,
                "no-data-text": _ctx.$t('components.infrastructure.fleetHealth.empty')
              }, {
                "asset-template": _withCtx(({ data }) => [
                  _createElementVNode("span", null, _toDisplayString(data.data.name || data.data.serialNumber), 1)
                ]),
                "category-template": _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["wl-category-badge", `wl-category-badge--${data.data.assetCategory}`])
                  }, _toDisplayString(_ctx.categoryLabels[data.data.assetCategory] || data.data.assetCategory), 3)
                ]),
                "gwid-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(data.data.gwId), 1)
                ]),
                "battery-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatVoltage(data.data.currentBatteryMv)), 1)
                ]),
                "trend-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.formatTrend(data.data.trendMvPerDay)), 1)
                ]),
                "days-template": _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["small font-monospace", _ctx.isUrgent(data.data.daysToLow) ? 'text-danger fw-bold' : 'text-muted'])
                  }, _toDisplayString(data.data.daysToLow ?? '—'), 3)
                ]),
                "eta-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.formatEta(data.data.etaLowBattery)), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxLoadPanel, { enabled: false }),
                  _createVNode(_component_DxPaging, { "page-size": 10 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "name",
                    caption: _ctx.$t('components.infrastructure.fleetHealth.columns.asset'),
                    "min-width": 130,
                    "allow-sorting": false,
                    "cell-template": "asset-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "assetCategory",
                    caption: _ctx.$t('components.infrastructure.fleetHealth.columns.category'),
                    "min-width": 110,
                    "allow-sorting": false,
                    "cell-template": "category-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "gwId",
                    caption: _ctx.$t('components.infrastructure.fleetHealth.columns.gwId'),
                    "min-width": 190,
                    "allow-sorting": false,
                    "cell-template": "gwid-template",
                    "hiding-priority": 2
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "currentBatteryMv",
                    caption: _ctx.$t('components.infrastructure.fleetHealth.columns.battery'),
                    "min-width": 100,
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "battery-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "trendMvPerDay",
                    caption: _ctx.$t('components.infrastructure.fleetHealth.columns.trend'),
                    "min-width": 100,
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "trend-template",
                    "hiding-priority": 1
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "daysToLow",
                    caption: _ctx.$t('components.infrastructure.fleetHealth.columns.daysToLow'),
                    "min-width": 150,
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "days-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "etaLowBattery",
                    caption: _ctx.$t('components.infrastructure.fleetHealth.columns.eta'),
                    "min-width": 140,
                    "allow-sorting": false,
                    "cell-template": "eta-template",
                    "hiding-priority": 0
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source", "column-hiding-enabled", "no-data-text"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}